var _rect, _path, _path2, _circle;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPhone(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 81,
    viewBox: "0 0 80 81",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.5,
    width: 80,
    height: 80,
    rx: 40,
    fill: "#E6E5FF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M50.5 21.5H31.75C29.6789 21.5 28 23.1789 28 25.25V55.25C28 57.3211 29.6789 59 31.75 59H50.5C52.5711 59 54.25 57.3211 54.25 55.25V25.25C54.25 23.1789 52.5711 21.5 50.5 21.5Z",
    fill: "white",
    stroke: "#8E8CEE",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M46.0747 31.3841C45.7815 31.1038 45.4333 30.8815 45.0502 30.7298C44.667 30.5781 44.2563 30.5 43.8415 30.5C43.4268 30.5 43.0161 30.5781 42.6329 30.7298C42.2497 30.8815 41.9016 31.1038 41.6084 31.3841L40.9998 31.9655L40.3913 31.3841C39.7991 30.8182 38.9958 30.5003 38.1582 30.5003C37.3206 30.5003 36.5173 30.8182 35.925 31.3841C35.3327 31.9499 35 32.7174 35 33.5177C35 34.318 35.3327 35.0855 35.925 35.6513L36.5335 36.2327L40.9998 40.5L45.4662 36.2327L46.0747 35.6513C46.368 35.3712 46.6007 35.0386 46.7595 34.6725C46.9183 34.3064 47 33.914 47 33.5177C47 33.1214 46.9183 32.729 46.7595 32.3629C46.6007 31.9968 46.368 31.6642 46.0747 31.3841Z",
    fill: "#8E8CEE",
    stroke: "#8E8CEE",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 41.5,
    cy: 53.5,
    r: 1.5,
    fill: "#8E8CEE"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhone);
export default __webpack_public_path__ + "static/media/phone.f1ba23550dde26761686a574364ef3b5.svg";
export { ForwardRef as ReactComponent };